<!--<div class="inspection-wrapper">-->
<!--    <ng-container *ngIf="(poleList?.poleItems$ | async)?.length > 0">-->
<!--        <div class="details-wrapper">-->
<!--            <div class="section-header">Inspected {{(poleList?.reviewedPolesCount$ | async)}} of {{(poleList?.poleItems$ | async)?.length}} Poles</div>-->

<!--            <div class="name-value-grid">-->
<!--                <div class="name-text">Poles:</div>-->
<!--                <div-->
<!--                    class="value-text">{{(poleList?.currentPoleItems$ | async)?.length}} of {{(poleList?.poleItems$ | async)?.length}}</div>-->

<!--                <div class="name-text">Images:</div>-->
<!--                <div class="value-text">{{(poleList?.currentImagesCount$ | async)}} of {{(poleList?.imagesCount$ | async)}}</div>-->
<!--            </div>-->

<!--            &lt;!&ndash;    <div class="namevalue-text">{{inspectionService.defects}} poles with defect notes</div>&ndash;&gt;-->
<!--        </div>-->
<!--    </ng-container>-->
<!--</div>-->

<div class="details-wrapper"
     *ngIf="(poleList?.currentPoleItem$ | async)?.pole?.name">
<!--    // TODO JLA: Reimplement-->
<!--    <div class="section-header">Pole {{(poleList?.currentPoleIndex$ | async) + 1}}/{{(poleList?.poleItems$ | async)?.length}}</div>-->
    <div class="section-header">Pole Details</div>
    <div class="name-value-grid">
        <div class="name-text">Pole:</div>
        <div class="value-text">{{(poleList?.currentPoleItem$ | async)?.pole?.name}}
            <span *ngIf="(poleList?.currentPoleItem$ | async)?.pole?.name2">({{(poleList?.currentPoleItem$ | async)?.pole?.name2}})</span>
        </div>

        <div class="name-text">Coords:</div>
        <div class="value-text"><a target="_gmaps" [href]="googleLink$ | async">{{latLon$ | async}}</a></div>

        <div class="name-text">{{config.getDepotLabel()}}:</div>
        <div class="value-list">
            <div class="value-text">{{(poleList?.currentPoleItem$ | async)?.pole?.depot?.name}}</div>
        </div>
        <div class="name-text">Feeders:</div>
        <div class="value-list">
            <div class="value-text"
                 *ngFor="let feeder of (poleList?.currentPoleItem$ | async)?.pole?.feeders?.items">{{feeder?.feeder?.name}}</div>
        </div>
    </div>
    <div class="name-value-list"
         *ngIf="((poleList?.currentPoleItem$ | async)?.inspectionBatches$ | async)?.length !== 0">
        <div class="list-name-text">Inspection Batches:</div>
        <div class="value-list">
            <div class="list-value-text"
                 *ngFor="let batch of ((poleList?.currentPoleItem$ | async)?.inspectionBatches$ | async)">
                {{batch?.inspectionBatchName}}
            </div>
        </div>
    </div>
</div>


<div class="details-wrapper"
     *ngIf="(poleList?.currentPoleImage$ | async)?.image">
    <div class="section-header">Image Details</div>
    <div class="name-value-grid">
        <div class="name-text">Image:</div>
        <div class="value-text"
             placement="top">{{(poleList?.currentPoleImage$ | async)?.image.filename}}</div>

        <div class="name-text">Timestamp:</div>
        <div class="value-text">{{(poleList?.currentPoleImage$ | async)?.image.timestamp | date: 'short'}}</div>

        <div class="name-text">AGL:</div>
        <div class="value-text">{{(poleList?.currentPoleImage$ | async)?.image.agl | number: '1.1-1'}} m</div>

        <div class="name-text">2D Dist:</div>
        <div class="value-text">{{(poleList?.currentPoleImage$ | async)?.range2D | number: '1.1-1'}} m</div>

        <div class="name-text">GSD:</div>
        <div class="value-text">{{(poleList?.currentPoleImage$ | async)?.gsdmm | number: '1.1-2'}} mm/px</div>
    </div>
</div>
